import {
  brandSpecificStaticText,
  staticText,
} from '../../../utils/translations/staticText';
import { money101Translation } from './money101';
import { moneyHeroTranslation } from './moneyhero';
import { moneyMaxTranslation } from './moneymax';

const baseTranslations = staticText({
  product_card_grid_apply_now: {
    _: 'Apply Now',
    zh: '立即申請',
  },
  product_card_grid_view_details: {
    _: 'View Details',
    zh: '查看詳情',
  },
  product_card_grid_view_all_rewards: {
    _: 'View all {count} rewards',
    zh: '查看 {count} 個獎賞選擇',
  },
  product_card_grid_view_less: {
    _: 'View less',
    zh: '收起',
  },
  product_card_grid_worth: {
    _: 'Worth',
    zh: '價值',
  },
});

export const TRANSLATIONS = brandSpecificStaticText({
  _: baseTranslations,
  money101: money101Translation,
  moneyhero: moneyHeroTranslation,
  moneymax: moneyMaxTranslation,
});
